<template>
  <div class="person-area user-detail-commonbg" v-if="showLock && editData.id">
    <div class="user-detail-title">
      <h3><i></i>{{ typeText }}信息</h3>
    </div>
    <div class="user-detail-list">
      <div class="list-content" v-for="(item, index) in editData.h5Card" :key="index">
        <span>{{ item.title }}</span>
        <span>{{ item.value || '-' }}</span>
      </div>
      <div class="list-content wrapmode" v-show="paginateList.length > 0">
        <span>回访情况</span>
        <div class="back-list-wrap">
          <div class="back-area" v-for="(item, index) in paginateList" :key="index">
            <span>回访内容：</span>
            <span>{{ item.vist_str }}</span>
            <span>{{ item.visit_creator }} 回访于 {{ item.instime }}</span>
          </div>
        </div>
      </div>
      <div class="list-content">
        <span>备注</span>
        <div class="remark-content">
          {{ memoText ? memoText : '暂无备注' }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  FIB_TO_TRAINING,
  // TRAINING_TO_FIB,
  FIB_TO_JOB,
  // JOB_TO_FIB
} from '@/const/sync';

export default {
  computed: {
  },
  props: {
    showType: {
      type: Number,
      default: 0
    },
    showId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      typeText: '',
      editData: {},
      syncInfo: {},
      paginateList: [],
      traingId: '',
      jobId: '',
      fibId: '',
      memoText: '',
      showLock: false,
    };
  },
  methods: {
    // 获取对应系统id
    getCustomerId() {
      this.$http._post({
        url: '/index/sync/read',
        data: { from: this.showId, types: [FIB_TO_TRAINING, FIB_TO_JOB] }
      }).then(({ data }) => {
        this.getTrueId(data);
        if (this.showType === 1 && this.traingId) {
          this.getTrainingData(this.traingId);
          this.getPaginate(`/training/visit/paginate/userid/${this.traingId}`);
          this.showLock = true;
        }
        if (this.showType === 2 && this.jobId) {
          this.getJobData(this.jobId);
          this.getPaginate(`/job/visit/paginate/userid/${this.jobId}`);
          this.showLock = true;
        }
      });
    },
    // 获取考培信息
    getTrainingData(customerId) {
      this.$http._get({
        url: `/training/customer/resource/id/${customerId}`,
      }).then(({ data }) => {
        this.editData = data;
        this.memoText = data.memo;
      });
    },
    // 获取就职信息
    getJobData(customerId) {
      this.$http._get({
        url: '/job/member/read',
        data: { id: customerId }
      }).then(({ data }) => {
        this.editData = data;
        this.memoText = data.remark;
      });
    },
    // 获取回访列表
    getPaginate(reqUrl) {
      this.$http._get({
        url: reqUrl
      }).then(({ data }) => {
        this.paginateList = data.data;
      });
    },
    // 获取真实类型id
    getTrueId(data) {
      data.forEach((item) => {
        if (item.creator === '-121') {
          this.traingId = item.sync_to;
        }
        if (item.creator === '-205') {
          this.jobId = item.sync_to;
        }
      });
    },
    // 类型文字
    textLoad() {
      switch (this.showType) {
        case 1:
          this.typeText = '考培';
          break;
        case 2:
          this.typeText = '就职';
          break;
        case 3:
          this.typeText = '蓝火';
          break;
        default:
          this.typeText = '未知应用';
          break;
      }
    }
  },
  watch: {
  },
  mounted() {
    this.$nextTick(() => {
      this.getCustomerId();
    });
    this.textLoad();
  }
};
</script>
<style scoped>

</style>
